import React from "react";
import "./Navigation.css";
import Logo from "../../../assets/logo.png";
import useLocation from "../../../utils/Location";
import { getWhatsappLink } from "../../../utils/getWhatsappNumber";
export const Navigation = () => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);
  return (
    <div className="Container">
      <div className="Wrapper">
        <div className="LogoWrapper">
          <img src={Logo} />
        </div>
        <div className="ButtonWrapper">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            <button type="button">
              Get yours today</button>
          </a>
        </div>
      </div>
    </div>
  );
};
